// @ts-nocheck
import ServError from "components/ServError/ServError";
import Page from "Pages/Page/Page";
import React from "react";
import {
	Routes,
	Route,
} from "react-router-dom";
import NestedPagesMenu from "./Menu/NestedPagesMenu";
import "./NestedPages.css";

export default function NestedPages(props) {
	let base_url = (props.baseUrl ? props.baseUrl : "");
	let pathname = base_url;

	if (!props.pages)
		return (false);
	return (
		<div className="NestedPages">
			<NestedPagesMenu items={props.pages} baseUrl={base_url} home={props.home}/>
			<Routes>
				{
					props.pages.map((sub_page, index) => {
						// In v6, nested <Routes> matches against the remaining path
						// after the parent route prefix, so use relative paths
						let pathsArr = [];
						if (sub_page.paths) {
							pathsArr = sub_page.paths.map((sub_path) => {
								// Strip leading slash for relative matching
								return sub_path.replace(/^\//, '');
							});
						} else {
							pathsArr = [sub_page.url.replace(/^\//, '')];
						}

						const suffix = sub_page.exact === false ? "/*" : "";

						return pathsArr.map((p, pIndex) => (
							<Route
								key={index + "-" + pIndex}
								path={p + suffix}
								element={
									<Page
										{...sub_page}
										title=""
										url={base_url + sub_page.url}
										{...sub_page.props}
									/>
								}
							/>
						));
					})
				}
				<Route path="*" element={<ServError />} />
			</Routes>
		</div>
	);
}
